/*
 * TimeField — одно поле «время» (м:сс.ммм) для всех тулов, где человек вписывает
 * момент в записи: /trim, /video-trim, /ringtone.
 *
 * Почему это общий примитив, а не функция в блейде (2026-09-28, чат 634 —
 * «не получается вырезать кусочек из песни посередине», телефон):
 *   В трёх блейдах жили ТРИ разные копии разбора, и каждая молча портила ввод.
 *   /trim и /video-trim: всё, что не «м:сс.ммм», шло в parseFloat —
 *     «1,10» → 1 с, «1:10,5» → 1 с, «1.10» → 1,1 с, а «0:59.999» с дописанным
 *     «1:10» (касание ставит курсор в КОНЕЦ поля) → 0. Начало и конец падали
 *     в одну точку, и «Вырезать» отказывал «выделите область»; хуже — вырез
 *     уезжал в первую секунду, и человек получал файл, в котором вырезано
 *     не то, без единого предупреждения (стенд: убрано 0…1 с вместо 1:00–1:30).
 *   /ringtone: <input type=number> с oninput, который переписывал значение на
 *     каждой клавише, — набрать число там было нельзя вовсе.
 *
 * Правила разбора (что набирают на телефоне, где «:» спрятано на второй раскладке):
 *   «1:10», «1:10.5», «1:10,5», «01:02:03»  — минуты:секунды[,доли], часы
 *   «70», «70.5», «70,5», «,5»              — секунды
 *   «1.10», «1,10», «1.10,500»              — русская запись «минута.секунды»:
 *        ровно ДВЕ цифры после знака и < 60 → минуты и секунды (как «12.30»
 *        во времени суток). Одна или три цифры — это доли секунды («70,5»).
 *   всё остальное                           — null. Отказ виден человеку: поле
 *        возвращает прежнее значение и подсвечивается, тул говорит, что не так.
 *
 * format() округляет до миллисекунды, а не отбрасывает хвост: 59.9996 с —
 * это «1:00.000», а не «0:59.999», как печатала старая копия.
 *
 * bind() — всё, что нужно полю на телефоне и на компьютере:
 *   · касание выделяет значение целиком — набор ЗАМЕНЯЕТ его, а не дописывает;
 *   · цифровая клавиатура (inputmode=decimal): «1,10» набирается без «:»;
 *   · применяется по Enter / уходу из поля, а НЕ на каждую клавишу;
 *   · пока поле в фокусе, refresh() не перетирает то, что человек печатает.
 * Сторож — tests/js/time-field.test.mjs.
 */
(function (root) {
    'use strict';

    function frac(digits) {
        return digits ? parseInt(digits, 10) / Math.pow(10, digits.length) : 0;
    }

    function parse(raw, opts) {
        if (raw === null || raw === undefined) return null;
        // Прод, первые сутки (2026-09-29): «1;30» (точка с запятой соседствует с «:» на
        // клавиатурах телефонов) и «1:30.» (знак в конце) — опечатки, а не другое время.
        var s = String(raw).replace(/[\s  ]+/g, '').replace(/[：∶;]/g, ':').replace(/[.,]$/, '');
        if (!s) return null;
        var m;
        // ч:мм:сс[.доли]
        if ((m = s.match(/^(\d+):([0-5]?\d):([0-5]?\d)(?:[.,](\d+))?$/))) {
            return parseInt(m[1], 10) * 3600 + parseInt(m[2], 10) * 60 + parseInt(m[3], 10) + frac(m[4]);
        }
        // м:сс[.доли]; секунды могут быть больше 59 — «0:90» это 90 с, иного прочтения нет
        if ((m = s.match(/^(\d+):(\d{1,3})(?:[.,](\d+))?$/))) {
            return parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + frac(m[3]);
        }
        var dotted = !(opts && opts.dottedMinutes === false);
        // «1.10,500» — минута.секунды,доли
        if (dotted && (m = s.match(/^(\d+)[.,]([0-5]\d)[.,](\d{1,3})$/))) {
            return parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + frac(m[3]);
        }
        // «1.10» / «1,10» / «70» / «70,5»
        if ((m = s.match(/^(\d*)(?:[.,](\d+))?$/)) && (m[1] || m[2])) {
            var whole = m[1] ? parseInt(m[1], 10) : 0;
            if (dotted && m[1] && m[2] && m[2].length === 2 && parseInt(m[2], 10) < 60) {
                return whole * 60 + parseInt(m[2], 10);
            }
            return whole + frac(m[2]);
        }
        return null;
    }

    function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }

    // «м:сс.ммм» (или «м:сс» с {ms:false}; {ms:'auto'} — доли только когда они
    // есть и без хвостовых нулей: «1:20», «1:20.5», «1:20.25»). Минуты не
    // переходят в часы, если не попросить {hours:true} («1:15:00»): так пишут
    // поля /trim и соседей, а parse() понимает оба вида.
    function format(sec, opts) {
        if (typeof sec !== 'number' || !isFinite(sec) || sec < 0) sec = 0;
        var ms = Math.round(sec * 1000);
        var want = opts && opts.ms;
        var withMs = want === 'auto' ? ms % 1000 !== 0 : want !== false;
        if (!withMs) ms = Math.floor(ms / 1000) * 1000;
        var m = Math.floor(ms / 60000);
        var s = Math.floor((ms % 60000) / 1000);
        var out = (opts && opts.hours && m >= 60)
            ? Math.floor(m / 60) + ':' + pad(m % 60, 2) + ':' + pad(s, 2)
            : m + ':' + pad(s, 2);
        if (!withMs) return out;
        var f = pad(ms % 1000, 3);
        return out + '.' + (want === 'auto' ? f.replace(/0+$/, '') : f);
    }

    // Форма ввода без самих чисел — для телеметрии «как люди набирают время».
    function shape(raw) {
        return String(raw == null ? '' : raw).replace(/\d+/g, 'd').slice(0, 16);
    }
    // То же с длиной каждой группы цифр («1.30» → «1.2», «1.5» → «1.1»): по одной
    // форме «d.d» не отличить «минута.секунды» от «секунды.доли», а правило разбора
    // на этой разнице и стоит — проверять его надо по тому, что люди набирают.
    function dshape(raw) {
        return String(raw == null ? '' : raw).replace(/\d+/g, function (g) { return String(g.length); }).slice(0, 16);
    }

    function bind(input, o) {
        if (!input || input.__timeField) return input && input.__timeField;
        o = o || {};
        var focusedAt = 0;
        var lastGood = '';
        try {
            input.setAttribute('inputmode', 'decimal');
            input.setAttribute('autocomplete', 'off');
            input.setAttribute('autocorrect', 'off');
            input.setAttribute('autocapitalize', 'off');
            input.setAttribute('spellcheck', 'false');
            if (!input.hasAttribute('enterkeyhint')) input.setAttribute('enterkeyhint', o.next ? 'next' : 'done');
        } catch (_) {}

        function current() {
            var v = o.get ? o.get() : 0;
            return typeof v === 'number' && isFinite(v) ? v : 0;
        }
        // Вид поля — у тула свой: «1:20» там, где время целыми секундами, свой
        // формат там, где поле показывает часы (субтитры). Разбор от вида не зависит.
        function show(v) {
            if (typeof o.format === 'function') {
                try { var t = o.format(v); if (typeof t === 'string') return t; } catch (_) {}
            }
            return format(v, { ms: o.ms === undefined ? true : o.ms });
        }
        function refresh(force) {
            if (!force && document.activeElement === input) return;
            lastGood = show(current());
            input.value = lastGood;
        }
        function selectAll() {
            try { input.setSelectionRange(0, input.value.length); } catch (_) { try { input.select(); } catch (__) {} }
        }
        function flagInvalid(raw) {
            input.classList.add('tf-invalid');
            input.setAttribute('aria-invalid', 'true');
            setTimeout(function () {
                input.classList.remove('tf-invalid');
                input.removeAttribute('aria-invalid');
            }, 1800);
            if (typeof o.onInvalid === 'function') {
                try { o.onInvalid(raw); } catch (_) {}
            }
            if (o.slug) {
                try { window.__ae && window.__ae('feature_use', { slug: o.slug, f: 'time_field_invalid', field: o.field || input.id, shape: shape(raw), dshape: dshape(raw) }); } catch (_) {}
            }
        }
        function commit() {
            var raw = input.value;
            if (raw === lastGood) return;
            // Стёр поле и ушёл — это не «непонятное время»: вернуть прежнее молча.
            // Прод, первые сутки: 23 сессии получили «Время «» не распознано» ровно так.
            // У необязательного поля («Конец» = до конца записи) пустое — это значение:
            // тул передаёт его в `empty`, и стёртое поле снимает границу.
            if (!String(raw).trim()) {
                if (o.empty !== undefined && o.set) o.set(o.empty);
                refresh(true);
                if (o.slug) {
                    try { window.__ae && window.__ae('feature_use', { slug: o.slug, f: 'time_field_empty', field: o.field || input.id }); } catch (_) {}
                }
                return;
            }
            var v = parse(raw, o);
            if (v === null) {
                refresh(true);
                flagInvalid(raw);
                return;
            }
            var lo = typeof o.min === 'function' ? o.min() : (o.min || 0);
            var hi = typeof o.max === 'function' ? o.max() : o.max;
            if (typeof hi === 'number' && isFinite(hi)) v = Math.min(v, hi);
            v = Math.max(lo || 0, v);
            // Каждый набранный ввод — форма и длины цифр, без самих значений.
            if (o.slug) {
                var t = String(raw).trim();
                try { window.__ae && window.__ae('feature_use', { slug: o.slug, f: 'time_field_parsed', field: o.field || input.id, shape: shape(t), dshape: dshape(t) }); } catch (_) {}
            }
            if (o.set) o.set(v);
            refresh(true);
        }

        // Повторное «выделить всё» — только пока человек ещё ничего не набрал: на
        // занятой странице отложенный вызов успевал сработать ПОСЛЕ первой цифры и
        // стирал её («75» → «5», стенд /ringtone 2026-09-28).
        function untouched() { return document.activeElement === input && input.value === lastGood && Date.now() - focusedAt < 600; }
        input.addEventListener('focus', function () {
            focusedAt = Date.now();
            lastGood = input.value;
            selectAll();
            // Касание на телефоне ставит курсор ПОСЛЕ фокуса — выделяем ещё раз.
            setTimeout(function () { if (untouched()) selectAll(); }, 0);
        });
        input.addEventListener('mouseup', function (e) {
            // Chrome снимает выделение отпусканием кнопки, которая дала фокус.
            if (untouched()) e.preventDefault();
        });
        input.addEventListener('click', function () {
            if (untouched()) selectAll();
        });
        input.addEventListener('change', commit);
        input.addEventListener('blur', commit);
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
                var nx = typeof o.next === 'function' ? o.next() : o.next;
                if (nx && nx.focus) nx.focus(); else input.blur();
            } else if (e.key === 'Escape') {
                refresh(true);
                input.blur();
            }
        });

        var api = { refresh: refresh, commit: commit, input: input };
        input.__timeField = api;
        refresh(true);
        return api;
    }

    root.TimeField = { parse: parse, format: format, shape: shape, dshape: dshape, bind: bind };

    // Привязка полей при загрузке страницы — через очередь, а не DOMContentLoaded:
    //   (window.__timeFieldQ = window.__timeFieldQ || []).push(bindMyFields);
    // Скрипт с defer, упавший по сети, догружается запасным адресом уже ПОСЛЕ
    // DOMContentLoaded (а «пришло не то» проверяется на load), и привязка на
    // событии проходила мимо — поля оставались голыми (стенд ворктри под
    // нагрузкой, 2026-09-29). Очередь выполняет функцию, как только есть оба:
    // и поле, и примитив, — в каком бы порядке они ни появились.
    var queued = root.__timeFieldQ;
    root.__timeFieldQ = {
        push: function (fn) {
            if (typeof fn !== 'function') return;
            try { fn(root.TimeField); } catch (e) { setTimeout(function () { throw e; }, 0); }
        }
    };
    if (queued && queued.length) {
        for (var qi = 0; qi < queued.length; qi++) root.__timeFieldQ.push(queued[qi]);
    }
})(typeof window !== 'undefined' ? window : this);
